'use client';

import { AnnouncementProps } from '@/actions/user/dashboard/getAnnouncement';
import Popup from './Popup';

interface AnnouncementComponentProps extends AnnouncementProps {
  hideRemovePopup?: boolean;
}

export const HIDE_ANNOUNCEMENT_ID = 'hideAnnouncement';

const Announcement = ({
  title,
  description,
  image,
  hideRemovePopup,
  primaryCta,
}: AnnouncementComponentProps) => (
  <Popup
    title={title}
    description={description}
    image={image}
    id={HIDE_ANNOUNCEMENT_ID}
    hideRemovePopup={hideRemovePopup}
    primaryCta={primaryCta}
  />
);

export default Announcement;
